import React, { useState } from "react";
import "./Collapse.scss"; // 创建一个用于样式的 CSS 文件
import add_icon from "./../../HomePage/images/add_icon.png";
import munus_icon from "./../../HomePage/images/minus_icon.png";
const CollspseStyle = ({ children }) => {
  const [isOpen, setIsOpen] = useState(true);

  const toggleItem = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="collapse-item">
      <div className="collapse-title" onClick={toggleItem}>
        {children[0]}
        {isOpen ? (
          <img className="icon_size" alt="" src={munus_icon} />
        ) : (
          <img className="icon_size" alt="" src={add_icon} />
        )}
      </div>
      {isOpen && <div className="collapse-content">{children.slice(1)}</div>}
    </div>
  );
};

export default CollspseStyle;
